"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseRequestTypeEnum = void 0;
var ExpenseRequestTypeEnum;
(function (ExpenseRequestTypeEnum) {
    ExpenseRequestTypeEnum[ExpenseRequestTypeEnum["PURCHASE"] = 0] = "PURCHASE";
    ExpenseRequestTypeEnum[ExpenseRequestTypeEnum["INVOICE"] = 1] = "INVOICE";
    ExpenseRequestTypeEnum[ExpenseRequestTypeEnum["REIMBURSEMENT"] = 2] = "REIMBURSEMENT";
    ExpenseRequestTypeEnum[ExpenseRequestTypeEnum["TRIP_FOLDER"] = 3] = "TRIP_FOLDER";
    ExpenseRequestTypeEnum[ExpenseRequestTypeEnum["SUBSCRIPTION"] = 4] = "SUBSCRIPTION";
})(ExpenseRequestTypeEnum || (exports.ExpenseRequestTypeEnum = ExpenseRequestTypeEnum = {}));
